import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class RangeAuthorizationService {
  constructor(
    private apiService: ApiService
  ) {
   }
  update(data, type): Observable<any> {
    if (type === 'create') {
      return this.apiService.post(this.apiService.quotations + '/configuration', data).pipe(map(x => x));
    } else {
      return this.apiService.put(this.apiService.quotations + '/configuration', data).pipe(map(x => x));
    }
  }

  delete(hierarchyCode): Observable<any> {
    return this.apiService.delete(this.apiService.quotations + '/configuration' + '/' + hierarchyCode).pipe(map(x => x));
  }

  getRanges(request): Observable<any> {
    return this.apiService.post(this.apiService.quotations + '/configuration' + '/search', request).pipe(map(x => x));
  }

  getRange(hierarchyCode): Observable<any> {
    return this.apiService.get(this.apiService.quotations + '/configuration' + '/' + hierarchyCode).pipe(map(data => data));
  }
}


